import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/app/ui-bits";
import ProjectCloseoutCenter from "@/components/app/ProjectCloseoutCenter";
import { Flag as FlagIcon, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, Tile } from "./_shared";

export default function CloseoutPanel({ project }) {
  const [summary, setSummary] = useState(null);
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [a, b] = await Promise.allSettled([
          api.get(`/projects/${project.id}/closeout-summary`),
          api.get(`/closeout-forms?project_id=${project.id}`),
        ]);
        if (!alive) return;
        if (a.status === "fulfilled") setSummary(a.value.data);
        if (b.status === "fulfilled") setForms(b.value.data.items || []);
      } finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [project.id]);
  return (
    <div data-testid={`panel-closeout-${project.id}`}>
      <PanelHeader icon={FlagIcon} title="Close-out" subtitle="Final acceptance · CSAT · handover"
        action={<ProjectCloseoutCenter project={project} trigger={<Button size="sm" variant="outline">Center <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {summary && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-2">
          <Tile k="Status" v={summary.closeout_status || "—"} />
          <Tile k="CSAT" v={summary.csat_score != null ? `${summary.csat_score}/5` : "—"} />
          <Tile k="Stakeholders" v={summary.stakeholders_count ?? 0} />
          <Tile k="Forms" v={forms.length} />
        </div>
      )}
      {forms.length === 0 && !loading && <EmptyHint message="No close-out forms submitted yet." />}
      {forms.length > 0 && (
        <ul className="space-y-1.5">
          {forms.slice(0, 12).map((f) => (
            <li key={f.id} data-testid={`closeout-row-${f.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-28 truncate">{f.form_type || "—"}</span>
              <span className="min-w-0 flex-1 truncate">{f.title || f.summary || "Close-out form"}</span>
              <StatusBadge status={f.status} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
